import { useErrorNotificationApi } from '../useErrorNotificationApi';

const apiPath = `${process.env.REACT_APP_ADDRESS_API_PATH}/`;

const apiUrl = (path: string) => `${apiPath}v2/${path}`;

export function useAddressApi() {
  return useErrorNotificationApi(apiUrl);
}

export type CountryType = {
  country: string,
  countryIsoCode: string,
}

export type AddressFindByIdType = {
  id: string,
  houseNumber: string,
  subBuilding: string,
  houseName: string,
  postTown: string,
  street: string,
  postCode: string,
  country: string,
  district: string,
  countryIsoCode: string,
  region: string,
  matchedCountries: CountryType[],
  matchedRegions: {
    [key: string]: string[],
  },
}

export type AddressFindByPostCodeType = {
  country: string,
  countryIsoCode: string,
  region: string,
  matchedCountries: CountryType[],
  matchedRegions: {
    [key: string]: string[],
  },
}

export type AddressType = {
  houseNumber: string,
  subBuilding: string,
  houseName: string,
  postTown: string,
  street: string,
  postCode: string,
  country: string,
  region: string,
}

export type AddressSearchType = {
  id: string,
  text: string,
  description: string,
}

export type AddressFindType = {
  id: string,
  houseNumber: string,
  subBuilding: string,
  houseName: string,
  postTown: string,
  street: string,
  postCode: string,
  country: string,
}

export function useAddressSearchApi() {
  const { get } = useAddressApi();

  return {
    get: (search: string, limitToGreatBritain: boolean = false): Promise<AddressSearchType[]> => (search === ''
      ? Promise.resolve([])
      : get(`AddressSearch/FindAddress?searchText=${search}&limitToGreatBritain=${limitToGreatBritain}`)),
  };
}

export function useAddressFindByIdApi() {
  const { get } = useAddressApi();

  return {
    get: (id: string): Promise<AddressFindByIdType> => get(`AddressSearch/GetAddressById?addressId=${id}`),
  };
}

export function useAddressFindByPostCodeApi() {
  const { get } = useAddressApi();

  return {
    get: (postCode: string): Promise<AddressFindByPostCodeType> => get(`AddressSearch/GetPostcodeRegions?postcode=${postCode}`),
  };
}
